import React, { useEffect, useRef, useState } from 'react';
import { FlexRow, TableDataState, usePaginatedQueryV8 } from 'motion-components';
import { Card, Spinner } from 'react-bootstrap';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues, Filters } from './filters';
import { DataGrid } from './grid';
import { handleExport } from './export-columns';
import { gql, useApolloClient, useQuery } from '@apollo/client';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { StockTransactionsAggregateSection } from './aggregate-section';
import { endOfMonth, startOfMonth } from 'date-fns';
import { orderBy } from 'lodash';

const gqlGetWRPRec = gql`
  query getWastereceptionpoints($where: String, $offset: Int, $limit: Int, $order: String) {
    getWastereceptionpoints(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
        isActive
      }
      recordCount
    }
  }
`;

// Fetch Wastereceptionpoint Before Loading Page
export const WastereceptionpointTransactionsGridPage = observer(() => {
  const { appStore } = useRootStore();
  const collectorId = appStore.isCollector ? appStore.associatedId : undefined;
  const { data } = useQuery(gqlGetWRPRec, {
    variables: {
      where: JSON.stringify({ isActive: 1, collectorId: collectorId }),
      orderBy: 'id ASC',
      limit: 1,
    },
  });
  const WRPId = data?.getWastereceptionpoints.data[0].id;
  return (
    <>
      {!WRPId ? (
        <Spinner animation="border" />
      ) : (
        <WastereceptionpointTransactionsGridPage2
          initialWastereceptionpointId={WRPId}
        ></WastereceptionpointTransactionsGridPage2>
      )}
    </>
  );
});
/* ----------------------------------------------------------- */
/* ------------------------ Page ----------------------------- */
export const WastereceptionpointTransactionsGridPage2 = ({ initialWastereceptionpointId }) => {
  const { appStore, tableStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('WastereceptionpointTransactionsGridPage');

  const location = useLocation<any>();
  const history = useHistory();
  const [selected, setSelected] = useState<any>(null);
  const { t } = useTranslation();

  /* ------------------- Query ------------------------------- */
  const initOrderBy = 'transactionDate ASC';
  const query = usePaginatedQueryV8(
    gqlGetQuery,
    buildWhereFromFilterValues,
    location.state?.order ?? initOrderBy,
    appStore,
    true, //execFirstTime
    {
      wastereceptionpointId: initialWastereceptionpointId,
      startDate: startOfMonth(new Date()),
      endDate: endOfMonth(new Date()),
    }, // initFilterValues
  );
  const {
    loading,
    data,
    dataCount,
    error,
    initPageIndex,
    filtersChanged,
    gridPageChanged,
    queryState,
    queryParams,
    setQueryParams,
    refetch,
  } = query;

  const client = useApolloClient();

  const gridRef = useRef();

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  } else {
    return (
      <Card className="shadow">
        <Card.Header>
          <FlexRow>
            <Card.Title className="m-0">{t('Κινήσεις Αποθηκών')}</Card.Title>
          </FlexRow>
        </Card.Header>
        <Card.Body className="nopadding">
          {/* Φίλτρα */}
          <Filters
            onChange={filtersChanged}
            initialValues={queryState?.filterValues ?? {}}
            // disable={tableStore.state !== TableDataState.browse}
          />

          {!data && (
            <h5 className="mt-3 text-center text-secondary">
              {t('Επιλέξτε Αποθηκευτικό Χώρο Πρώτα')}
            </h5>
          )}

          {/* Grid */}
          {data && (
            <div>
              {/* SUMS for Period - load after data */}
              {data ? (
                <div className="mt-2 mb-3">
                  <StockTransactionsAggregateSection filters={queryState?.filterValues} />
                </div>
              ) : (
                <div className="mt-2" style={{ minHeight: '120px' }}>
                  <h5>{t('Αθροίσματα Κινήσεων Αποθηκών')}</h5>
                </div>
              )}

              <h5>{t('Αναλυτικές Κινήσεις Αποθηκών')}</h5>
              <DataGrid
                ref={gridRef}
                loading={loading}
                data={data}
                dataCount={dataCount}
                initPageIndex={initPageIndex}
                onPageChange={gridPageChanged}
                handleExport={() => {
                  handleExport(client, queryState, t);
                }}
                initOrderBy={queryParams?.order ?? initOrderBy}
                onOrderChange={(orderBy) => {
                  const newQueryParams = { ...queryParams, order: orderBy };
                  setQueryParams(newQueryParams);
                  history.replace({
                    pathname: location.pathname,
                    state: {
                      ...location.state,
                      order: orderBy,
                    },
                  });
                }}
                selected={selected}
                setSelected={setSelected}
                refetch={refetch}
              />
            </div>
          )}
        </Card.Body>
      </Card>
    );
  }
};
